import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService): (input: string) => string {
    var dateFilter = $filter('date');
    return function (input: string) {
        return input
            ? dateFilter(new Date(input), 'yyyy-MM-dd')
            : null;
    };
}
angular.module('naut')
    .filter('serverDate', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/filters/serverDate.filter.ts